import {
  GEOLOCATION_GET_USER_LOCATION,
  SET_BOOKING_FORM_VISIBILITY,
  SET_MESSAGE,
} from '../constants';

const initialState = {
  isGettingCurrenUserPosition: false,
  bookingFormVisible: false,
  message: {
    title: null,
    text: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GEOLOCATION_GET_USER_LOCATION:
      return {
        ...state,
        isGettingCurrenUserPosition: action.status,
      };

    case SET_BOOKING_FORM_VISIBILITY:
      return {
        ...state,
        bookingFormVisible: action.visible,
      };

    case SET_MESSAGE:
      return {
        ...state,
        message: !action.message ? initialState.message : action.message,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/ux.js